import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import config from '../../config'
import {
  Link,
  LinkIcon
} from '../../components'
import Styles from './InlineDonate.css'

@CSSModules(Styles, {allowMultiple:true})
export default class InlineDonate extends Component {
  render() {
    return <div styleName='inline-donate' aria-labelledby='inline-donate__headline'>

      <div styleName='inline-donate__icon' aria-hidden='true'>
        <LinkIcon faclass='fa-heart' nospace/>
      </div>

      <h3 id='inline-donate__headline' styleName='inline-donate__headline'>
        Support our work
      </h3>

      <h3 styleName='inline-donate__copy'>
        Your gift helps hold corporations accountable.
        Make a difference — donate today.
      </h3>

      <div styleName='inline-donate__link'>
        <Link
          to={config.links.donate}
          title='Donate to As You Sow'
          donatebanner
        >
          Donate
        </Link>
      </div>

    </div>
  }
}
